import PropTypes from 'prop-types'
import React from 'react'
import { DetailPage } from '../src/modules/ads/detail/components'
import { AdsDetailApi } from '../src/modules/ads/detail/api'
import { setCurrentAd, setIsServer } from '../src/modules/ads/detail/actions'
import { fetchCitiesByCountry } from '../src/modules/geoObjects/cities/actions'
import { fetchPageMetaTags } from '../src/modules/common/actions'
import { connect } from 'react-redux'
import { CookiesHelper } from '../src/core/cookiesHelper/CookiesHelper'
import { Page404 } from '../src/ui'
import initialState from '../src/modules/redux/initialState'
import { deepCopy } from '../src/utils'
import config from '../src/config/config.yaml'

class Ad extends React.Component {
  static async getInitialProps ({store, query, isServer, req}) {
    console.log('query', query)
    const api = new AdsDetailApi()
    const params = {seo: query.ad}
    let userId, token
    if (req) {
      userId = req.cookies.userId
      token = req.cookies.token
    } else {
      const cookies = new CookiesHelper()
      userId = cookies.get('userId')
      token = cookies.get('token')
    }

    let isPageExists = false

    const { ad, error } = await api.getAd(params)

    const adProps = !error && ad ? ad : null
    store.dispatch(setCurrentAd(adProps))
    store.dispatch(setIsServer(isServer))

    if (adProps && adProps.category && adProps.category.id) {
      await store.dispatch(fetchPageMetaTags({ category: adProps.category.id }))
      isPageExists = true
    }

    await store.dispatch(fetchCitiesByCountry(config.globalOptions.MontenegroId))

    return {
      title: isPageExists ? config.siteName : config.pages.notFoundTitle,
      isPageExists,
      state: Ad.getPageState(store, isPageExists)
    }
  }

  static getPageState (store, isPageExists = false) {
    const state = deepCopy(initialState)
    if (store) {
      const currentState = store.getState()

      state.user.auth.isAuthorized = currentState.user.auth.isAuthorized
      state.user.profile.error = currentState.user.profile.error
      state.user.profile.info = currentState.user.profile.info
      state.user.profile.favouriteAds = currentState.user.profile.favouriteAds
      state.user.profile.savedFilters = currentState.user.profile.savedFilters
      state.user.profile.favouriteProfiles = currentState.user.profile.favouriteProfiles

      state.common.transitions = currentState.common.transitions
      state.common.router = currentState.common.router
      state.common.is404 = !isPageExists
      state.common.userTypes = currentState.common.userTypes
      state.common.selectableUserTypes = currentState.common.selectableUserTypes
      state.common.isMobileDevice = currentState.common.isMobileDevice
      state.common.pageMetaTags = currentState.common.pageMetaTags
      state.common.pageMetaTagsSingle = currentState.common.pageMetaTagsSingle

      state.geoObjects.countries = currentState.geoObjects.countries
      state.geoObjects.regions = currentState.geoObjects.regions
      state.geoObjects.cities = currentState.geoObjects.cities

      state.ads.detail = currentState.ads.detail

      state.groups = currentState.groups

      state.categories = currentState.categories

      state.geoObjects.cities = currentState.geoObjects.cities

      state.form = currentState.form

      state.cart = currentState.cart
      state.orders = currentState.orders
    }
    return state
  }

  render () {
    const {isPageExists} = this.props
    return isPageExists ? <DetailPage /> : <Page404 />
  }
}

Ad.propTypes = {
  isPageExists: PropTypes.bool.isRequired
}

Ad.defaultProps = {
  isPageExists: false
}

export default connect(null)(Ad)
